import React, { useEffect, useState } from "react";

import { FeaturedDealsModule } from "@app/api/modules/featured-deals/featured-deals.module";
import { IOutFeaturedDealDTO } from "@app/components/deal-cards/new-deal-card/deal-card.interface";
import {
  getCorrectFeaturedDeals,
  getFeaturedDealsTitleWithWildCards,
  mapDealsToFeaturedDeals
} from "@app/api/wp-page-fetcher/module-selector/module-mappers";
import { useAppSelector } from "@app/redux/store";
import { FeaturedLayout } from "@app/components/featured-layout/featured-layout";

import { DealCardWrapper } from "@app/components/deal-cards/deal-card-wrapper/deal-card-wrapper";

export interface IFeaturedDealsComponentProps {
  module: FeaturedDealsModule;
}

const FeaturedDeals = (props: IFeaturedDealsComponentProps) => {
  const { currentMerchant } = useAppSelector((state) => state.merchantOverview);
  const { platformId } = useAppSelector((state) => state.settings);
  const [merchantSingleFilters, setMerchantSingleFilters] = useState<string | undefined>(undefined);

  const title = getFeaturedDealsTitleWithWildCards(props.module.title, currentMerchant?.name);

  const {
    subtitle,
    useSeeMoreCard,
    topCtaTitle,
    ctaButton,
    ctaDescription,
    featuredDeals,
    isMerchantSinglePage,
    amountOfDeals,
    filterIds,
    dealSelection,
    selectionChoice,
    pageUrl,
    labelFilter
  } = props.module;

  const [deals, setDeals] = useState<IOutFeaturedDealDTO[]>(featuredDeals || []);

  useEffect(() => {
    if (currentMerchant && isMerchantSinglePage) {
      const merchantFilterIds = currentMerchant.categories?.map((item) => item.id);
      const merchantFilters = merchantFilterIds?.join(";");
      setMerchantSingleFilters(merchantFilters);
      getDeals(merchantFilters, true);
    } else {
      getDeals(undefined, false);
    }
    setMerchantSingleFilters(undefined);
  }, [pageUrl]);

  const getDeals = async (merchantFilters?: string, merchantSinglePage?: boolean): Promise<void> => {
    const newDeals = await getCorrectFeaturedDeals({
      platformId,
      limit: amountOfDeals,
      filterIds,
      selectionChoice,
      dealSelection,
      merchantId: currentMerchant?.id.toString(),
      isMerchantSinglePage: merchantSinglePage,
      merchantSingleFilters: merchantFilters || merchantSingleFilters,
      labelFilter
    });

    setDeals(mapDealsToFeaturedDeals(newDeals || []));
  };

  const dealsToUse = deals && deals.length > 0 ? deals : featuredDeals;

  if (!dealsToUse || dealsToUse.length === 0) {
    return <></>;
  }

  return (
    <FeaturedLayout
      title={title}
      subtitle={subtitle}
      items={dealsToUse}
      renderItem={(item) => <DealCardWrapper deal={item} />}
      topCtaTitle={topCtaTitle}
      ctaCard={
        useSeeMoreCard
          ? {
              title: ctaDescription,
              subtitle: ctaButton?.title,
              href: ctaButton?.url || ""
            }
          : undefined
      }
      mobileMaxItemAmt={props.module.amountOfDealsMobile}
    />
  );
};

export { FeaturedDeals };
